<template>
  <div class="faq--wrapper">
    <h2>Frequently Asked Questions</h2>
    <div v-if="data && data.length > 0"><LsAccordion :data="data"></LsAccordion></div>
    <Accordion v-if="withAdditionalQuestions" class="faq--additional-questions">
      <AccordionItem>
        <template slot="accordion-trigger">
          <h3>I have additional questions</h3>
        </template>
        <template slot="accordion-content">
          <li class="content">
            <div>
              <LsIcon type="phone" color="primary" size="lg" />
              <div class="header-text">
                <span class="header-text-top">Have additional questions?</span>
                <span class="header-text-description">Call Support</span>
              </div>
            </div>
          </li>
        </template>
      </AccordionItem>
    </Accordion>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import Accordion from '@/components/common/LsAccordion/accordion.vue';
import AccordionItem from '@/components/common/LsAccordion/accordion-item.vue';
import LsAccordion from '@/components/common/LsAccordion/LsAccordion.vue';
import LsIcon from '@/components/common/LsIcon/LsIcon.vue';

export default {
  name: 'LsFAQ',
  components: {
    Accordion,
    AccordionItem,
    LsAccordion,
    LsIcon,
  },
  props: {
    withAdditionalQuestions: VueTypes.bool.def(true),
    data: VueTypes.arrayOf(
      VueTypes.shape({
        title: VueTypes.string.isRequired,
        content: VueTypes.string.isRequired,
      }).isRequired
    ).isRequired,
  },
};
</script>

<style lang="scss" scoped>
.faq--wrapper {
  h2 {
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 18px;
    margin-bottom: 11px;
  }

  .faq--additional-questions {
    border-top: 1px solid $primary-light;

    .content {
      padding: 5px;
      margin-top: 5px;
      background: $primary-light;

      > div {
        display: flex;

        span {
          font-size: $size-7;
        }
      }

      .header-text {
        margin-left: 7px;

        @media (min-width: $desktop) {
          max-width: 370px;
        }

        .header-text-top {
          display: flex;
        }

        .header-text-description {
          font-weight: 700;
        }
      }
    }
  }
}
</style>
